import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IPageNotFoundState} from '../models/page-not-found-state.model';

export const selectPageNotFoundState = createFeatureSelector<IPageNotFoundState>(EState.PageNotFound);
export const selectIsPageNotFound = createSelector(
  selectPageNotFoundState,
  (state: IPageNotFoundState) => state?.isPageNotFound
);
export const selectRedirectUrl = createSelector(
  selectPageNotFoundState,
  (state: IPageNotFoundState) => state?.redirectUrl
);
